import React from 'react';

const HANDLE_SIZE = 10;
const MIN_WIDTH = 10;
const MIN_HEIGHT = 10;

/**
 * Directions layout:
 *
 *  nw   n   ne
 *   w  [ ]  e
 *  sw   s   se
 */

const HANDLES = {
  n: {
    cursor: 'ns-resize',
    style: { top: -HANDLE_SIZE / 2, left: '50%', right: 0, height: HANDLE_SIZE },
  },
  s: {
    cursor: 'ns-resize',
    style: { bottom: -HANDLE_SIZE / 2, left: '50%', right: 0, height: HANDLE_SIZE },
  },
  e: {
    cursor: 'ew-resize',
    style: { right: -HANDLE_SIZE / 2, top: '50%', bottom: 0, width: HANDLE_SIZE },
  },
  w: {
    cursor: 'ew-resize',
    style: { left: -HANDLE_SIZE / 2, top: '50%', bottom: 0, width: HANDLE_SIZE },
  },
  ne: {
    cursor: 'nesw-resize',
    style: { top: -HANDLE_SIZE / 2, right: -HANDLE_SIZE / 2 },
  },
  nw: {
    cursor: 'nwse-resize',
    style: { top: -HANDLE_SIZE / 2, left: -HANDLE_SIZE / 2 },
  },
  se: {
    cursor: 'nwse-resize',
    style: { bottom: -HANDLE_SIZE / 2, right: -HANDLE_SIZE / 2 },
  },
  sw: {
    cursor: 'nesw-resize',
    style: { bottom: -HANDLE_SIZE / 2, left: -HANDLE_SIZE / 2 },
  },
};

export function ResizeOverlay({ element, setResizing }) {
  function startResize(e, dir) {
    e.stopPropagation();
    setResizing(true);

    const startX = e.clientX;
    const startY = e.clientY;

    const {
      x,
      y,
      width,
      height,
    } = element.layout;

    function onPointerMove(ev) {
        console.log('on pointer move')
      const dx = ev.clientX - startX;
      const dy = ev.clientY - startY;

      let newX = x;
      let newY = y;
      let newWidth = width;
      let newHeight = height;

      if (dir.includes('e')) {
        newWidth = Math.max(MIN_WIDTH, width + dx);
      }

      if (dir.includes('s')) {
        newHeight = Math.max(MIN_HEIGHT, height + dy);
      }

      if (dir.includes('w')) {
        newWidth = Math.max(MIN_WIDTH, width - dx);
        newX = x + dx;
      }

      if (dir.includes('n')) {
        newHeight = Math.max(MIN_HEIGHT, height - dy);
        newY = y + dy;
      }

      element.onResize?.({
        x: newX,
        y: newY,
        width: newWidth,
        height: newHeight,
      });
    }

    function onPointerUp() {
      setResizing(false);
      window.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerup', onPointerUp);
    }

    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', onPointerUp);
  }

  return (
    <>
      {Object.entries(HANDLES).map(([dir, cfg]) => (
        <Handle
          key={dir}
          dir={dir}
          cursor={cfg.cursor}
          style={{ ...cfg.style, background: 'red' }}
          onDown={startResize}
        />
      ))}
    </>
  );
}

function Handle({ dir, style, cursor, onDown }) {
  return (
    <div
      onPointerDown={(e) => onDown(e, dir)}
      style={{
        position: 'absolute',
        width: style.width ?? HANDLE_SIZE,
        height: style.height ?? HANDLE_SIZE,
        cursor,
        background: 'transparent', // invisible but interactive
        ...style,
      }}
    />
  );
}
